import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Paper,
  Typography,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import axios from 'axios';
import envConfig from '../../../bin/env.config';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 200,
  },
  table: {
    minWidth: 650,
  },
}));

const transformData = (data) => {
  // Extract unique names (banner names)
  const names = [...new Set(data.map(item => item.name))];
  
  // Extract unique weeks and sort in descending order
  const weeks = [...new Set(data.map(item => item.data_year_week))].sort((a, b) => b - a);
  
  // Create columns array
  const columns = ['Banner', ...weeks];
  
  // Create rows array
  const rows = names.map(name => {
    const row = [name];
    weeks.forEach(week => {
      const item = data.find(d => d.name === name && d.data_year_week === week);
      row.push(item ? item.count : 0);
    });
    return row;
  });
  
  return {
    columns,
    rows
  };
};

const PriceRecordsByWeekTable = ({ project }) => {
  const classes = useStyles();
  const token = useSelector((state) => state.session.token);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/data-freshness-reporting/price-records-by-week/summary?user_type_id=${project.user_type_id}`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        // Transform the data into rows and columns format
        const transformedData = transformData(response.data.data || []);
        setData(transformedData);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch price records by week');
        setLoading(false);
      }
    };
    if (project && project.user_type_id) {
      fetchData();
    }
  }, [project]);

  if (loading) {
    return (
      <div className={classes.loadingContainer}>
        <CircularProgress />
      </div>
    );
  }

  if (error) {
    return (
      <Paper className={classes.root}>
        <Typography color="error">{error}</Typography>
      </Paper>
    );
  }

  if (!data || !data.rows || !data.columns) {
    return null;
  }

  return (
    <div className={classes.root}> 
      <Typography variant="h5" gutterBottom style={{ fontWeight: 700 }}>
        Price records by week
      </Typography>
      <TableContainer component={Paper}>
        <Table className={classes.table} size="small">
          <TableHead>
            <TableRow>
              {data.columns.map((col, idx) => (
                <TableCell key={idx}><b>{col}</b></TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.rows.map((row, i) => (
              <TableRow key={i}>
                {row.map((cell, j) => (
                  <TableCell key={j}>{cell}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default PriceRecordsByWeekTable; 